import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { wholesalerViewRequest } from "../../../redux/wholesaler/WholesalerAction";
import "../../../style/style.css";
import { StyledContainer, styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import ReusableFormFields from "../../constant/reusableFormFields";
import { APP_LINK } from "../../global/MenuItems";
import ImagePreviewDialog from "../../constant/commonImageDialog";
import pdf from "../../../image/pdf.jpg";
import uploadImage from "../../../image/wmremove-transformed-Photorooms.jpg";

const inputFields = [
  {
    name: "reg_no",
    label: "Register No",
    readOnly: true,
  },
  {
    name: "name",
    label: "Company Name",
    readOnly: true,
  },
  {
    name: "first_name",
    label: "First Name",
    readOnly: true,
  },
  {
    name: "last_name",
    label: "Last Name",
    readOnly: true,
  },
  {
    name: "email",
    label: "Email Address",
    readOnly: true,
  },
  {
    name: "contact",
    label: "Phone No",
    readOnly: true,
  },
  {
    name: "address",
    label: "Address",
    size: "extraLarge",
    readOnly: true,
  },
  {
    name: "tax_id",
    label: "Tax ID",
    readOnly: true,
  },
  {
    name: "company_reg_no",
    label: "Company Register No",
    readOnly: true,
  },
  {
    name: "license_no",
    label: "License No",
    readOnly: true,
  },
  {
    name: "working_time",
    label: "Working Time",
    readOnly: true,
  },
  {
    name: "status",
    label: "Status",
    readOnly: true,
  },
];

const ViewWholesaler = () => {
  const {
    register,
    setValue,
    control,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [imagePreview, setImagePreview] = useState(null);
  const [proofPreview, setProofPreview] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [proofSelected, setProofSelected] = useState([]);

  const wholesalerState = useSelector(
    (state) => state?.wholesaler?.viewWholesaler?.data || {}
  );
  const wholesalerList = wholesalerState || [];

  const handleCancel = () => {
    navigate(APP_LINK.ONBOARDEDWHOLESALER);
  };

  useEffect(() => {
    if (id) {
      dispatch(wholesalerViewRequest(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (wholesalerList) {
      setValue("reg_no", wholesalerList?.reg_no);
      setValue("first_name", wholesalerList?.first_name);
      setValue("last_name", wholesalerList?.last_name);
      setValue("name", wholesalerList?.name);
      setValue("address", wholesalerList?.address);
      setValue("email", wholesalerList?.email);
      setValue("contact", wholesalerList?.contact);
      setValue("tax_id", wholesalerList?.tax_id);
      setValue("company_reg_no", wholesalerList?.company_reg_no);
      setValue("license_no", wholesalerList?.license_no);
      setValue("working_time", wholesalerList?.working_time);
      setValue("status", wholesalerList?.status);
      const statusLabel =
        wholesalerList?.status === 1
          ? "Active"
          : wholesalerList?.status === 0
          ? "Pending"
          : "Inactive";
      setValue("status", statusLabel);

      const imageUrl = wholesalerList?.prof_image;
      if (imageUrl) {
        setImagePreview(imageUrl);
      }

      const proofUrls = Array.isArray(wholesalerList?.govt_id_image)
        ? wholesalerList.govt_id_image.filter((img) => !!img)
        : wholesalerList?.govt_id_image
        ? [wholesalerList.govt_id_image]
        : [];
      setProofPreview(proofUrls);
    }
  }, [wholesalerList, setValue]);

  const handleImageClick = (file, isPdf = false) => {
    if (isPdf) {
      window.open(file, "_blank");
    } else if (file !== uploadImage) {
      setSelectedImage(file);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <Container>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1> Wholesaler Profile Overview</h1>
              </Typography>
            </Box>
            <StyledContainer>
              <img
                src={imagePreview}
                alt="Profile"
                width={120}
                height={120}
                style={styles.image}
                onClick={() => handleImageClick(imagePreview)}
              />
            </StyledContainer>
          </Grid>

          {/* Proof Image Section */}
          <Grid item xs={12} sm={6}>
            <Box sx={styles.fileBoxContainer}></Box>
            <StyledContainer>
              {(proofPreview || []).map((proof, index) => {
                const isPdf = proof.toLowerCase().endsWith(".pdf");

                return (
                  <img
                    key={index}
                    src={isPdf ? pdf : proof}
                    alt="Proof"
                    width={120}
                    height={120}
                    style={styles.image}
                    onClick={() => {
                      if (isPdf) {
                        window.open(proof, "_blank");
                      } else {
                        handleImageClick(proof);
                      }
                    }}
                  />
                );
              })}
            </StyledContainer>
          </Grid>

          {/* Form Fields Section */}
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
            />

            {/* Submit and Cancel Buttons */}
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Back"
                    size="medium"
                    onClick={handleCancel}
                    buttonStyle="StyledButton"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>

      {/* Popup Dialog */}
      <ImagePreviewDialog
        open={open}
        onClose={handleClose}
        selectedImage={selectedImage}
        proofSelected={proofSelected}
      />
    </Container>
  );
};

export default ViewWholesaler;
